import { Profile } from '../types/profiles';
import { api } from './api';

class ProfileService {
  async getProfiles(customerId?: string): Promise<Profile[]> {
    const response = await api.get('/roles', {
      params: customerId ? { customerId } : undefined,
    });
    return response.data;
  }

  async getProfile(id: string, customerId?: string): Promise<Profile> {
    const response = await api.get(`/roles/${id}`, {
      params: customerId ? { customerId } : undefined,
    });
    return response.data;
  }
}

export const profileService = new ProfileService(); 